import { z } from 'zod';

export const SLogin = z.object({
  username: z.string('Silahkan isi Username').min(1, 'Silahkan isi Username'),
  password: z
    .string('Silahkan isi Kata Sandi')
    .min(1, 'Silahkan isi Kata Sandi'),
});
export type TLogin = z.infer<typeof SLogin>;
